import type IEndPoint from 'interfaces/EndPointTypes.ts';
import { AuthProtect, BaseURLSelect } from '@/common/enum';
import { IADetails } from 'interfaces/ia.interface.ts';
import BaseURLConfig from '@/common/enum/BaseURLSelection.ts';

export const getIADataSet = (url: string): IEndPoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    method: 'GET',
    url,
    defaultBaseURL: BaseURLSelect.DMA,
  };
};

export const getIAData = (url: string): IEndPoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    method: 'GET',
    url,
    defaultBaseURL: BaseURLSelect.DMA,
  };
};

export const postIAData = (url: string, data: Partial<IADetails>): IEndPoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    method: data?.id ? 'PUT' : 'POST',
    url: url,
    defaultBaseURL: BaseURLSelect.DMA,
    data,
  };
};

export const deleteIA = (url: string): IEndPoint => ({
  authorization: AuthProtect.REQUIRED,
  method: 'DELETE',
  url,
  defaultBaseURL: BaseURLConfig.DMA,
});
